import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/grailed-seller-guide';

export default function Example() {
  return (
    <>
      <Head>
        <title>Grailed Seller Guide: Everything You Need to Know</title>
        <meta name='description' content='Read on the must-knows for those looking to sell on Grailed. ' />
        <link rel='canonical' href='https://tools.oneshop.com/blog/grailed-seller-guide' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/grailed-seller-guide' />
        <meta property='og:title' content='Grailed Seller Guide: Everything You Need to Know' />
        <meta property='og:description' content='Read on the must-knows for those looking to sell on Grailed. ' />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='February 22nd, 2022' />
        <meta property='article:modified_time' content='February 22nd, 2022' />
        <meta property='article:tag' content='Grailed' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
